import { render, staticRenderFns } from "./EligibleCustomers.vue?vue&type=template&id=5d9b1dc8&scoped=true"
import script from "./EligibleCustomers.vue?vue&type=script&lang=js"
export * from "./EligibleCustomers.vue?vue&type=script&lang=js"
import style0 from "./EligibleCustomers.vue?vue&type=style&index=0&id=5d9b1dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b1dc8",
  null
  
)

export default component.exports